import { z } from 'zod'

import type { PanelUserAvailabilityUpdateSlotRequest } from '@/api/v1/generated-api.gen'
import { httpService } from '@/api/v1/http.service'
import type { AvailabilityFormDay } from '@/constants/availability-form'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

import {
  setAvailabilityErrorsMapper,
  type SetAvailabilityPayload
} from '../constants/set-availability-payload'

export const parseAvailabilitySlots = (
  slots: AvailabilityFormDay
): PanelUserAvailabilityUpdateSlotRequest[] =>
  slots.map(({ time, isOptional }) => ({
    start_time: z.string().parse(time.from),
    end_time: z.string().parse(time.to),
    is_optional: isOptional
  }))

const useSetUserAvailability = (options: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    ...options,
    mutationFn: (data: SetAvailabilityPayload) =>
      httpService.panel.panelUsersAvailabilityUpdate(
        data.semesterId,
        data.userId,
        {
          monday: parseAvailabilitySlots(data.monday),
          tuesday: parseAvailabilitySlots(data.tuesday),
          wednesday: parseAvailabilitySlots(data.wednesday),
          thursday: parseAvailabilitySlots(data.thursday),
          friday: parseAvailabilitySlots(data.friday),
          saturday: parseAvailabilitySlots(data.saturday),
          sunday: parseAvailabilitySlots(data.sunday)
        }
      ),
    fieldErrorsMapper: setAvailabilityErrorsMapper
  })

export default useSetUserAvailability
